// extracted by mini-css-extract-plugin
export default {"table":"Table_table__YTxTN","tablehead":"Table_tablehead__r4gC6","tablebody":"Table_tablebody__deCN0","btns":"Table_btns__61WLb","btn":"Table_btn__iZPaj"};